<template>
	<sf-data-table
		ref="dataTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		index
		:columns="powTourSttsManagementCols"
		:rows="powTourSttsManagements"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		fit="fit"
		:customExcel="excelFunc"
		@changedPage="changedPage"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'powBttmInfmNo'">
				<template v-if="slotProps.row.ngPrvsCt && Number(slotProps.row.ngPrvsCt) > 0">
					<span class="highlighted" @click="() => openReport(slotProps.row)">
						<template v-if="slotProps.row.powBttmInfmNo"> {{ slotProps.row.powBttmInfmNo }} </template>
						<template v-else-if="!!slotProps.row.pprrId"> {{ getMessage_('QWCC001472') }} </template>
					</span>
				</template>
			</template>
			<template v-else-if="slotProps.column.property === 'powLnNm' ">
				<template v-if="!flgPqylsGrp ">
					<span class="highlighted" @click="() => clickRow(slotProps.row)">
						{{ slotProps.row.powLnNm }}
					</span>
				</template>
				<template v-if="flgPqylsGrp ">
					{{ slotProps.row.powLnNm }}
				</template>
			</template>
		</template>
		<template v-slot:actionsLeft>
			<!-- test code -->
			<sf-button
				v-if="isButton_(scrId, 'CC') && (flgPqyapGrp || flgPqyrvGrp || flgPqyrgGrp || flgOsGrp)"
				line
				icon="file"
				:onClick="addAction"
			>
				{{ getMessage_('QWCC001083') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import PowTourRgst from '@pqy/ptin/PowTourRgst/PowTourRgst';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			flgPqyapGrp: false, //관리자(승인)
			flgPqyrvGrp: false, //중간관리자(검토)
			flgPqyrgGrp: false, //업무담당자(작성)
			flgOsGrp: false, //관리자
			flgPqylsGrp: false
		};
	},
	async created() {
		this.getPqyap();
		this.getPqyrv();
		this.getPqyrg();
		this.getOs();
		this.getPqyls();
		this.getPqyop();
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		...qmsComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		...utils, //커스텀 엑셀다운로드시
		async getPqyls() {
			this.flgPqylsGrp = await this.inclUsrGrp_('PQYLS'); //생산품질 관리자(승인)
			//console.log('getPqyap >>> ', this.flgPqyapGrp);
		},
		async getPqyap() {
			this.flgPqyapGrp = await this.inclUsrGrp_('PQYAP'); //생산품질 관리자(승인)
			//console.log('getPqyap >>> ', this.flgPqyapGrp);
		},
		async getPqyrv() {
			this.flgPqyrvGrp = await this.inclUsrGrp_('PQYRV'); //생산품질 중간관리자(검토)
			//console.log('getPqyrv >>> ', this.flgPqyrvGrp);
		},
		async getPqyrg() {
			this.flgPqyrgGrp = await this.inclUsrGrp_('PQYRG'); //생산품질 일반사용자(작성)
			//console.log('getPqyrg >>> ', this.flgPqyrgGrp);
		},
		async getOs() {
			this.flgOsGrp = await this.inclUsrGrp_('OS'); //관리자
			//console.log('flgOsGrp >>> ', this.flgOsGrp);
		},
		openModal() {
			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC000926'), //타이틀바 값 변수관리 엑셀 업로드
				apiGubun: 'powTourStts', //업무구분값
				flag: 'I' //INSERT는 i Update U로 만듬
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		resetTable() {
			this.$emit('Refresh');
		},
		openReport(row) {
			this.$emit('openReport', row);
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		async clickRow(row) {
			const { insnDd, powLnCd, ipnNos } = row;
			const name = this.getMessage_('QWCC001388');
			let item = {
				name,
				component: PowTourRgst,
				scrId: this.powTourRgstScrId, //이동할 scrId
				msgKey: 'QWCC001388'
			};

			await this.getScreen_({ scrId: item.scrId });
			await this.$sf_removeTab(item.scrId);
			await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, insnDd, powLnCd, ipnNos });
		},
		async addAction() {
			//let flag = '';
			//선택한 라인,오늘날짜로 등록된 데이터가 있는지 체크
			//this.powTourSttsManagements.forEach((element, index) => {
			//	if (element.insnDd == this.$moment().format('YYYYMMDD') && element.powLnCd == this.searchParams.powLnCd) {
			//		flag = 'E';
			//	}
			//});

			if (this.searchParams.powLnCd == '') {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001752') });
				//} else if (flag == 'E') {
				//	this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001753') });
			} else {
				const name = this.getMessage_('QWCC001388');
				let item = {
					name,
					component: PowTourRgst,
					scrId: this.powTourRgstScrId, //이동할 scrId
					msgKey: 'QWCC001388'
				};
				await this.getScreen_({ scrId: item.scrId });
				await this.$sf_removeTab(item.scrId);
				await this.$sf_addTab(item, item.scrId, {
					scrId: item.scrId,
					insnDd: this.$moment().format('YYYYMMDD'),
					powLnCd: this.searchParams.powLnCd,
					ipnNos: '1000'
				});
			}
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				powLnCd: this.searchParams.powLnCd,
				strDt: this.searchParams.strDt,
				endDt: this.searchParams.endDt,
				powBttmInfmNo: this.searchParams.powBttmInfmNo
			});

			const url = `${BASE_URL}/pqy/ptin/powTourStts/v1/powTourSttss/excel` + queryStr;

			const params = { url, columns: this.powTourSttsManagementCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	}
};
</script>
